module.exports = __webpack_public_path__ + "img/shopping_bag.68fcbf66.svg";